module.exports = __webpack_public_path__ + "static/media/dribble-loader.91931453.gif";